import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import MobileMenuItem from '../../MobileMenu/MobileMenuItem';
import MobileMenuLink from '../../MobileMenu/MobileMenuLink';
import { DSIcon } from '../../../../base';
import SeparatorRedesign from '../../MobileMenu/SeparatorRedesign';
import AlertsIcon from '../../icons/AlertsIcon';
import PaymentsIcon from '../../icons/PaymentsIcon';
import Colors from '../../utils/colors';

const HeaderNavMobileLoggedIn = ({ changeCity = false }) => {
  return (
    <>
      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('my-profile')}
          target="_blank"
          rel="nofollow"
        >
          <DSIcon name="perfect_for_couples" />
          {trans('logout.text.my-profile')}{' '}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('marketplace.favorites')}
          target="_blank"
          rel="nofollow"
        >
          <DSIcon name="fav_line" /> {trans('favorites.title.favorites')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('marketplace.alerts')}
          target="_blank"
          rel="nofollow"
        >
          <AlertsIcon color={Colors.medium} />{' '}
          {trans('logout.text.search-preference')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('my-bookings')}
          target="_blank"
          rel="nofollow"
        >
          <DSIcon name="key_locker" />
          {trans('logout.text.user-area')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('my-payments')}
          target="_blank"
          rel="nofollow"
        >
          <PaymentsIcon color={Colors.medium} />
          {trans('header.nav.my-payments.link')}
        </MobileMenuLink>
      </MobileMenuItem>

      {changeCity && (
        <MobileMenuItem>
          <MobileMenuLink className="change-city" href={getPagePath('landing')}>
            <DSIcon name="map" /> {trans('change_city.title')}
          </MobileMenuLink>
        </MobileMenuItem>
      )}

      <SeparatorRedesign />

      <MobileMenuItem>
        <MobileMenuLink target="_blank" href={getPagePath('how-it-works')}>
          <DSIcon name="double_bed" />
          {trans('how_it_works.title')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink target="_blank" href={getPagePath('refer-a-friend')}>
          <DSIcon name="diamond" /> {trans('my-referrals.cta.revamp')}
        </MobileMenuLink>
      </MobileMenuItem>
    </>
  );
};

HeaderNavMobileLoggedIn.propTypes = {
  changeCity: PropTypes.bool
};

export default HeaderNavMobileLoggedIn;
